import React from "react";
import { getMaxLength } from "../../../../application/domain/proc-management/util/input-max-length";
import { FormFieldLabel } from "../../../atoms/proc-management/form";
import { InputNoticeList } from "./input-notice-list";
import { SimpleTextInput } from "./simple-text-input";
import type { InputProps, PathProps } from "./types";

const notices = [
  "手続きページへ表示する管轄名を設定できます。",
  "自治体の名前が冒頭に補完されます。未入力の場合、自治体の名前のみが表示されます。",
];

type Props = InputProps & PathProps & { value?: string; errorMsg?: string };

export const ProcedureGroupNameInput: React.FC<Props> = ({
  value,
  onChange,
  disabled,
  basePath,
  shouldDisplayError,
  errorMsg,
}) => {
  return (
    <div className="field mb-6">
      <FormFieldLabel label="管轄表示名" />
      <InputNoticeList notices={notices} />
      <SimpleTextInput
        onChange={onChange}
        basePath={basePath}
        value={value}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        errorMsg={errorMsg}
        maxLength={getMaxLength("groupName")}
      />
    </div>
  );
};
